import React from 'react';
import { RadioToggle, RadioToggleButton } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { useDebounce } from '../../../utils';
export function HotelPriceCalendarPriceModeToggle({ value: valueProp, onChange, }) {
    const { resourceStrings: { TOTAL_PRICE, HOTELDETAILS_PERPERSONPRICE }, } = useGlobalContext();
    const [value, setValue] = React.useState(valueProp);
    const handlePriceToggle = useDebounce((newValue) => {
        onChange(newValue);
    }, 300);
    const handleChangeValue = React.useCallback((newValue) => {
        // Update the local state to re-render the toggle
        setValue(newValue);
        // Call the debounced update
        handlePriceToggle(newValue);
    }, [handlePriceToggle]);
    return (React.createElement(RadioToggle, { value: value, onChangeValue: handleChangeValue },
        React.createElement(RadioToggleButton, { value: "total", "data-id": "price-toggle-total" }, TOTAL_PRICE),
        React.createElement(RadioToggleButton, { value: "perPerson", "data-id": "price-toggle-per-person" }, HOTELDETAILS_PERPERSONPRICE)));
}
